import actions from '../actions/FavoritesActions';

const { RESET_EDIT_INLINE_STATE, SET_EDIT_FOLDER, SET_EDIT_INLINE } = actions;

const editInlineState = (state = {}, payload) => {
    switch (payload.type) {
        case RESET_EDIT_INLINE_STATE:
            return {
                editInline: false,
                editFolder: false,
            };
        case SET_EDIT_FOLDER:
            return { ...state, editFolder: payload.editFolder };
        case SET_EDIT_INLINE:
            return { ...state, editInline: payload.editInline };
        default:
            return state;
    }
};

export default editInlineState;
